export var SignUpOriginEnum;
(function (SignUpOriginEnum) {
    SignUpOriginEnum["WEB"] = "web";
    SignUpOriginEnum["CLI"] = "cli";
    SignUpOriginEnum["VERCEL"] = "vercel";
})(SignUpOriginEnum || (SignUpOriginEnum = {}));
export var ApiAuthSchemeEnum;
(function (ApiAuthSchemeEnum) {
    ApiAuthSchemeEnum["BEARER"] = "Bearer";
    ApiAuthSchemeEnum["API_KEY"] = "ApiKey";
    ApiAuthSchemeEnum["KEYLESS"] = "Keyless";
})(ApiAuthSchemeEnum || (ApiAuthSchemeEnum = {}));
export var PassportStrategyEnum;
(function (PassportStrategyEnum) {
    PassportStrategyEnum["JWT"] = "jwt";
    PassportStrategyEnum["JWT_CLERK"] = "jwt-clerk";
    PassportStrategyEnum["HEADER_API_KEY"] = "headerapikey";
    PassportStrategyEnum["KEYLESS"] = "keyless";
})(PassportStrategyEnum || (PassportStrategyEnum = {}));
export const NONE_AUTH_SCHEME = 'None';
export var PermissionsEnum;
(function (PermissionsEnum) {
    // Workflows
    PermissionsEnum["WORKFLOW_READ"] = "org:workflow:read";
    PermissionsEnum["WORKFLOW_WRITE"] = "org:workflow:write";
    // Webhooks
    PermissionsEnum["WEBHOOK_READ"] = "org:webhook:read";
    PermissionsEnum["WEBHOOK_WRITE"] = "org:webhook:write";
    // Environments
    PermissionsEnum["ENVIRONMENT_WRITE"] = "org:environment:write";
    // API keys
    PermissionsEnum["API_KEY_READ"] = "org:apikey:read";
    PermissionsEnum["API_KEY_WRITE"] = "org:apikey:write";
    // Events
    PermissionsEnum["EVENT_WRITE"] = "org:event:write";
    // Integrations
    PermissionsEnum["INTEGRATION_READ"] = "org:integration:read";
    PermissionsEnum["INTEGRATION_WRITE"] = "org:integration:write";
    // Messages
    PermissionsEnum["MESSAGE_READ"] = "org:message:read";
    PermissionsEnum["MESSAGE_WRITE"] = "org:message:write";
    // Partner Integrations
    PermissionsEnum["PARTNER_INTEGRATION_READ"] = "org:partnerintegration:read";
    PermissionsEnum["PARTNER_INTEGRATION_WRITE"] = "org:partnerintegration:write";
    // Subscribers
    PermissionsEnum["SUBSCRIBER_READ"] = "org:subscriber:read";
    PermissionsEnum["SUBSCRIBER_WRITE"] = "org:subscriber:write";
    // Topics
    PermissionsEnum["TOPIC_READ"] = "org:topic:read";
    PermissionsEnum["TOPIC_WRITE"] = "org:topic:write";
    // Billing
    PermissionsEnum["BILLING_WRITE"] = "org:billing:write";
    // Org Metadata
    PermissionsEnum["ORG_METADATA_WRITE"] = "org:metadata:write";
    // Notifications
    PermissionsEnum["NOTIFICATION_READ"] = "org:notification:read";
    // Bridge endpoint
    PermissionsEnum["BRIDGE_WRITE"] = "org:bridge:write";
    // Organization Settings
    PermissionsEnum["ORG_SETTINGS_WRITE"] = "org:settings:write";
    PermissionsEnum["ORG_SETTINGS_READ"] = "org:settings:read";
})(PermissionsEnum || (PermissionsEnum = {}));
export const ALL_PERMISSIONS = Object.values(PermissionsEnum);
//# sourceMappingURL=auth.js.map